import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import common from 'ui-react-common';

import { actionCreator, stateSelectors } from '../../../redux/disclosures';

const Checkbox = common.ui.components.forms.Checkbox;
const Disclosure = common.ui.components.disclosure;
const { List, Type } = common.ui.components;

export const validation = {
    validateOn: ['blur', 'change'],
    required: true,
    message: {
        default: 'Please sign our disclosures',
    },
};

export const disclosureTypes = {
    accountCreation: 'account-creation',
};

/**
 * Component to render the list of disclosures for a given page.
 *
 * Currently supports account creation only.
 *
 * todo: need to separate AccountCreationDisclosures render the correct list based on this.props.type
 *
 * @type type
 */
export class Disclosures extends Component {
    componentDidMount() {
        const { fetchDisclosures, type } = this.props;
        fetchDisclosures(type);
    }

    disclosuresList() {
        const { disclosures = {} } = this.props;

        // determining mobile view by checking to see if inner width of app is less than 768px (inner width of iPad)
        const isViewMobile = window.innerWidth < 768;

        if (isViewMobile) {
            return (
                <Fragment>
                    <li>
                        <Disclosure
                            id="bank-privacy-notice"
                            config={disclosures['bank-privacy-notice']}
                        />
                    </li>
                    <li>
                        <Disclosure
                            id="credit-pull-authorization"
                            config={disclosures['credit-pull-authorization']}
                        />
                    </li>
                    <li>
                        <Disclosure
                            id="our-privacy-notice"
                            config={disclosures['our-privacy-notice']}
                        />
                    </li>
                    <li>
                        <Disclosure
                            id="our-terms-of-use"
                            config={disclosures['our-terms-of-use']}
                        />
                    </li>
                </Fragment>
            );
        }

        return (
            <li>
                <Disclosure
                    id="bank-privacy-notice"
                    config={disclosures['bank-privacy-notice']}
                />
        ,{' '}
                <Disclosure
                    id="credit-pull-authorization"
                    config={disclosures['credit-pull-authorization']}
                />
        ,{' '}
                <Disclosure
                    id="our-privacy-notice"
                    config={disclosures['our-privacy-notice']}
                />
                {' and '}
                <Disclosure
                    id="our-terms-of-use"
                    config={disclosures['our-terms-of-use']}
                />
            </li>
        );
    }

    render() {
        const { disclosures={}, clientResidentState=false, location=false } = this.props;
        const caDisclosureRequiredStates = disclosures['ca-financial-privacy-notice'] ? disclosures['ca-financial-privacy-notice'].requiredStates : [];
        const checkboxOptions = [
            {
                id: 'disclosures',
                value: 'disclosures',
                label:
          'By checking this box you are indicating that you have read, consent to, and affix your electronic signature to the following documents',
            },
        ];
        if (!disclosures) {
            return null;
        }
        if (location === 'PIIRetry' && caDisclosureRequiredStates.indexOf(clientResidentState) === -1) {
            return null;
        }
        return (
            <Fragment>
                <Checkbox
                    id="disclosures"
                    name="disclosures"
                    options={checkboxOptions}
                    validation={validation}
                />
                <List id="accountCreationDisclosures" variant="indented" size="medium">
                    {
                        !location
            && <li>
                <Disclosure id="e-consent" config={disclosures['e-consent']} className="sprk-u-TextAlign--left" />
            </li>
                    }
                    {
                        caDisclosureRequiredStates.indexOf(clientResidentState) > -1
            && <li>
                <Disclosure
                    id="ca-financial-privacy-notice"
                    config={disclosures['ca-financial-privacy-notice']}
                />
            </li>
                    }
                    { !location && this.disclosuresList() }
                </List>
            </Fragment>
        );
    }
}

Disclosures.propTypes = {};

const mapStateToProps = (state) => ({
    disclosures: stateSelectors.getDisclosures(state),
});

const mapDispatchToProps = (dispatch) => ({
    fetchDisclosures: (requiredFor) =>
        dispatch(actionCreator.fetchDisclosures(requiredFor)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Disclosures);
